import PropTypes from 'prop-types'
import { useState } from 'react'
import { connect } from 'react-redux'

import CloseIcon from '../../../assets/CloseIcon'
import DotsIcon from '../../../assets/DotsIcon'
import EmailIcon from '../../../assets/EmailIcon'
import LocationIcon from '../../../assets/LocationIcon'
import PhoneIcon from '../../../assets/PhoneIcon'
import TrashIcon from '../../../assets/TrashIcon'
import useCheckMobileScreen from '../../../common/hooks/use-check-mobile-screen-hook'
import { convertToTitleCase } from '../../../common/utils/appUtils'
import { formatProductListLabel } from '../../../common/utils/productUtils'
import PopupCard from '../PopupCard/PopupCard'
import './Card.scss'

const Card = (props) => {
  const isMobile = useCheckMobileScreen()
  const [isCardActive, setIsCardActive] = useState(false)
  const [isDisableDelete, setIsDisableDelete] = useState(false)
  const [deleteVoucherPopup, setDeleteVoucherPopup] = useState(false)
  const handleDeleteHoldSaleOrder = async (e, saleId) => {
    if (!saleId) return
    setIsDisableDelete(true)
    setDeleteVoucherPopup(false)

    e.stopPropagation()
    await props?.handleDeleteHoldSaleOrder(saleId)
    setIsDisableDelete(false)
  }

  return (
    <div
      className={`card product ${props?.cardCrown && 'spaceTop'}`}
      onClick={props.handleClick}
    >
      {props?.saleData?.status === 'HOLD' && (
        <button
          className="btn btnDelete"
          onClick={(e) => {
            e.stopPropagation()
            setDeleteVoucherPopup(true)
          }}
        >
          <TrashIcon />
        </button>
      )}
      {deleteVoucherPopup && (
        <PopupCard
          header="Cancel Draft & Hold Sales?"
          body="Do you want to cancel this Sales?"
        >
          <button
            className="btn btnPrimaryOutlined dFlex"
            onClick={(e) => {
              e.stopPropagation()
              setDeleteVoucherPopup(false)
            }}
          >
            No
          </button>
          <button
            className="btn btnPrimary dFlex "
            onClick={(e) => handleDeleteHoldSaleOrder(e, props?.saleData?.id)}
            disabled={isDisableDelete}
          >
            Yes, Cancel
          </button>
        </PopupCard>
      )}
      {props.cardCrown && (
        <div className={`cardCrown ${props.primary && 'primary'}`}>
          {props.cardCrown}
        </div>
      )}
      <div
        className={`cardHeader dFlex flexNowrap aiCenter ${
          !props.noHeaderBorder && 'border'
        }`}
      >
        {props.userInitials && (
          <div className="cardIcon dFlex jcContentCenter aiCenter">
            <div className="userInitials">{props.userInitials}</div>
          </div>
        )}
        <div className="cardHeaderDetails">
          <div className="cardHeaderDetails">
            {props.headerSup && (
              <div className="headerSup">{props.headerSup}</div>
            )}
            <div className="headerMain">
                {props.headerMain}
                {props.designation && (
                  <span className="designation">({props.designation})</span>
                )}
              </div>
          </div>
          {props.headerProduct && (
            <div className={`productName`}>
              {props.headerProduct.productType && (
                <span className={`item name ${props.strong ?? 'strong'}`}>
                  {props.headerProduct.productType}
                </span>
              )}
              {props.headerProduct.productCategory && (
                <span className={`item type ${props.strong ?? 'strong'}`}>
                  {props.headerProduct.productCategory}
                </span>
              )}
              {props.headerProduct.quantity && (
                <span className={`item space ${props.strong ?? 'strong'}`}>
                  {props.headerProduct.quantity}
                </span>
              )}
              {props.headerProduct.rpu && (
                <span className={`item space ${props.strong ?? 'strong'}`}>
                  {props.headerProduct.rpu}
                </span>
              )}
            </div>
          )}
          {props.exchangeItem && (
            <div className="exchangeItem">{props.exchangeItem}</div>
          )}
        </div>

        {props.cardRight && (
          <div
            className={`cardHeaderRight alignSelf ${
              props.nowrap ? 'nowrap' : ''
            } ${(() => {
              const amount = Number(
                props.cardRight.replace('BDT ', '').replace(/,/g, '')
              )

              return amount > 0 ? 'textGreen' : amount < 0 ? 'textRed' : ''
            })()}`}
          >
            {props.cardRight}
          </div>
        )}

        {props.users && (
          <div className="cardHeaderRight">
            {isCardActive ? (
              <span
                onClick={(e) => {
                  e.stopPropagation()
                  setIsCardActive(false)
                }}
              >
                <CloseIcon />
              </span>
            ) : (
              <span
                onClick={(e) => {
                  e.stopPropagation()
                  setIsCardActive(true)
                }}
              >
                <DotsIcon />
              </span>
            )}
            {props.cardAction && (
              <ul
                className={`cardActionsWrapper ${
                  isCardActive ? 'show' : 'hide'
                }`}
              >
                {props?.cardAction?.map((action, index) => {
                  return (
                    <li
                      key={`action-${index}`}
                      className="actionItem"
                      onClick={(e) => {
                        e.stopPropagation()
                        setIsCardActive(false)
                        props?.onCardAction(action)
                      }}
                    >
                      {convertToTitleCase(action)}
                    </li>
                  )
                })}
              </ul>
            )}
          </div>
        )}
      </div>
      <div
        className={`cardBody ${props.cardFooter && 'border'} ${
          props.shippingAddress && 'borderBig'
        }`}
      >
        {props.product && (
          <div className={`productName`}>
            <span className={`item name ${props.strong ?? 'strong'}`}>
              {formatProductListLabel({
                name: props.product.productName,
                size: props.product.size,
                dose: props.product.dose,
                strength: props.product.strength,
                category: props.product.category,
              })}
            </span>
            <span className={`item space ${props.strong ?? 'strong'}`}>
              {props.product && props.product.quantity}
            </span>
          </div>
        )}
        {props.productDesc && (
          <div className={`productDesc ${props.cardFooter && 'strong'}`}>
            {props.productDesc || 'Lorem ipsum dolor sit amet consectetur.'}
          </div>
        )}
        <ul className="userContactDetails">
          {props.phone && (
            <li className="userContact dFlex">
              <PhoneIcon />
              {props.phone}
            </li>
          )}
          {props.email && (
            <li className="userContact">
              <EmailIcon />
              {props.email}
            </li>
          )}
          {props.location && (
            <li className="userContact">
              <LocationIcon />
              {props.location}
            </li>
          )}
        </ul>
        {props.documents && (
          <div className="documentsName">
            <span className="item name">Due Date: 04 Dec 2023</span>
            <span className="item type">Paymeny Mode: DiGi Pay</span>
          </div>
        )}
        {props.orderBook && (
          <div className="documentsName">
            <span className="item name">
              Order Qty: {props.orderBook.totalQuantity}
            </span>
            {props.orderBook.receivableQuantity && (
              <span className="item type">
                Received Qty: {props.orderBook.receivableQuantity}
              </span>
            )}
          </div>
        )}
        {props.sales && <div className="productDesc">{props.sales}</div>}
        {props.orderStatus && (
          <div className={`${props?.orderStatus?.color} orderStatus`}>
            {props?.orderStatus?.text}
          </div>
        )}
        {props.actionButtons && (
          <div className="actionButtons mt-5">
            <button className="btn btnPrimaryOutlined">CANCEL</button>
            <button className="btn btnPrimary ml-5">CONFIRM</button>
          </div>
        )}
        {props.billingAddress && (
          <div className="addressDetails">
            <div className="addressType">Billing Address</div>
            <div className="address dFlex flexNowrap">
              <LocationIcon />
              {props.billingAddress}
            </div>
          </div>
        )}
      </div>
      <div className="cardFooter">
        {props.cardFooter && (
          <div className="itemBack dFlex jc-space-even">
            {props.cardFooter.expiryDate && (
              <div className="item date dFlex flexColumn">
                <small>Expiry Date</small>
                {props.cardFooter.expiryDate}
              </div>
            )}
            {!isMobile && (
              <div className="item loss dFlex flexColumn ">
                <small>Return Loss</small>BDT{' '}
                {props.cardFooter.returnLossAmount}
              </div>
            )}
            {!isMobile && (
              <div className="item loss dFlex flexColumn no-border">
                <small>Receivable Amt</small>BDT{' '}
                {props.cardFooter.recievableAmounut}
              </div>
            )}
            {isMobile && (
              <div className="dFlex jcSpaceBetween aiCenter ">
                <div className="item loss dFlex flexColumn mt-2">
                  <small>Return Loss</small>BDT{' '}
                  {props.cardFooter.returnLossAmount}
                </div>
                <div className="item loss dFlex flexColumn">
                  <small>Receivable Amt</small>BDT{' '}
                  {props.cardFooter.recievableAmounut}
                </div>
              </div>
            )}
          </div>
        )}
        {props.shippingAddress && (
          <div className="addressDetails">
            <div className="addressType">Shipping Address</div>
            <div className="address dFlex flexNowrap">
              <LocationIcon />
              {props.shippingAddress}
            </div>
          </div>
        )}
        {props.address && (
          <div className="addressDetails">
            <div className="addressType"> Address</div>
            <div className="address dFlex flexNowrap">
              <LocationIcon />
              {props.address}
            </div>
          </div>
        )}
      </div>
      {props.actionIcon && (
        <div className="cardActionIcon">
          {props.actionIcon}
        </div>
      )}
    </div>
  )
}

const mapStateToProps = (state) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

Card.propTypes = {
  strong: PropTypes.bool,
  cardCrown: PropTypes.string,
  online: PropTypes.bool,
  product: PropTypes.bool,
  productDesc: PropTypes.bool,
  phone: PropTypes.bool,
  email: PropTypes.bool,
  location: PropTypes.bool,
  userInitials: PropTypes.bool,
  documents: PropTypes.bool,
  headerSup: PropTypes.string,
  headerMain: PropTypes.string,
  cardRight: PropTypes.string,
  actionButtons: PropTypes.bool,
}

export default connect(mapStateToProps, mapDispatchToProps)(Card)
